import { useState, useMemo } from "react";

import styled from "styled-components";
import fundo from "../../../styles/fundo.svg";



import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import logo1 from "./logo-1.png";
import logo6 from "./logo-6.png";

import { ImArrowLeft, ImArrowRight } from "react-icons/im";



const Geral = styled.div`
  max-width: 100%;
  overflow: auto;
  
  background-color: transparent;
  border-radius: 12px;
  box-shadow: 0px 0px 2px #ccc;


  @media (max-width:1367px) {
    margin: 5px;
    box-shadow: none;

  }

  @media (max-width: 1024px) {
    margin: 5px;
    box-shadow: none;
    margin-bottom: 100px;
  }


`;


const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  
  
`;

const Thead = styled.thead`
  background-color: #fff;

`;


export const Tbody = styled.tbody`
  background-color: #fefefe;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  
  ${({ noHover }) =>
    !noHover &&
    `
    &:hover {
      background-color: #f5f5f5;
    }
  `}

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const TrHead = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const Th = styled.th`
  color: #575757;
  padding: 18px 10px;
  font-size: 18px;
  text-align: center;
  font-weight: bold;

  cursor: pointer;
  &.hide-on-mobile {
    @media (max-width: 1024px) {
      display: none;
    }
  }





  @media (max-width: 1367px) {
    padding: 6px 5px;
    font-size: 12px;
  }
  @media (max-width: 1024px) {
    padding: 6px 5px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }
`;



export const Td = styled.td`
  padding: 25px 10px;

  font-size: 18px;
  color: #575757;
  background-color: ${(props) => props.zebra ? "#f2f2f2" : "transparent"};
    text-align: center;
  white-space: nowrap; 
  overflow: hidden;     
  text-overflow: ellipsis; 

  &.mobile-hide {
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 1367px) {
    padding: 6px;
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    padding: 6px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }

`;

export const CabecalhoTabela = styled.th`
  text-align: center;
  
  padding: 18px;
  color: white;

  h2{
    font-size: 2rem;
  }

  padding{
    font-size: 1.4rem;
  }

  
`;

const Button = styled.button`
  padding: 0px 20px ;
  cursor: pointer;
  border-radius: 2px;
  border: none;
  background-color:  #fff;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  margin: 5px;
  color: #575757;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);

  }
`;


const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;


  h2 {
    margin: 0;
    font-size: 32px;
    background-image: url(${fundo});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    /* Para suporte em alguns navegadores modernos */
    background-clip: text;
    color: transparent;
  }

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    h2 {
      font-size: 20px;
    }
  }
`;



const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  @media (max-width: 780px) {
    width: 100%;
    display: flex;
    justify-content: space-between;

    p {
      font-size: 10px;
    }
  }
`;
const IconGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Input = styled.input`
  width: 805px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 7px;
  height: 37px;

  
`;
export const Td3 = styled.td`
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;



const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.3);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;
const Grid = ({ showGrid, isLoading, total, dataIni, dataFim, caminhao }) => {


  //===========================TELA CHEIA==============================//
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full - screen mode: ${err.message}(${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };


  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(caminhao);



  //Input de pesquisa
  const handleSearch = async (term) => {
    try {
      const filtered = caminhao.filter((user) => {
        const equip = (user.COD_EQUIPAMENTO || '').toString().toLowerCase();



        const passaFiltroPesquisa = equip.includes(term.toLowerCase())

        return passaFiltroPesquisa
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
  };





  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//

  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    const parseValue = (value) => {
      if (typeof value === 'string') {
        // Remove % se houver, substitui vírgula por ponto, remove espaços
        return parseFloat(value.replace('%', '').replace(',', '.').trim()) || 0;
      }
      return value || 0;
    };

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        const aValue = parseValue(aValueRaw);
        const bValue = parseValue(bValueRaw);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);



  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };







  //=======================GERAR PDF==========================================//

  const getBase64FromImage = (imgSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve({ base64: canvas.toDataURL("image/png"), width: img.naturalWidth, height: img.naturalHeight });
      };

      img.onerror = () => reject(new Error("Erro ao carregar imagem"));
      img.src = imgSrc;
    });
  };


  const gerarPdf = async () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });

    // Marca d'água
    const { base64: marcaDaguaBase64, width: mw, height: mh } = await getBase64FromImage(logo1);
    const maxMarcaW = 400, maxMarcaH = 300;
    const ratioMarca = Math.min(maxMarcaW / mw, maxMarcaH / mh);
    const marcaW = mw * ratioMarca, marcaH = mh * ratioMarca;
    const centerX = (842 - marcaW) / 2, centerY = (595 - marcaH) / 2;

    // Cabeçalho
    const { base64, width, height } = await getBase64FromImage(logo6);
    const maxW = 200, maxH = 60;
    const ratio = Math.min(maxW / width, maxH / height);
    const displayW = width * ratio, displayH = height * ratio;

    doc.addImage(base64, 'PNG', 20, 10, displayW, displayH);
    doc.setFontSize(12);
    doc.setTextColor(87, 87, 87);
    doc.text("Aceitação CDC - Caminhão", 30, 70);
    doc.text(`Dados base: ${dataIni} á ${dataFim}`, 600, 70);


    // Cabeçalhos
    const headers = [
      "Frota",
      "Automática",
      "Auto. c/ Alteração",
      "Manual",
      "Sem Lat. Long.",
      "Com Lat. Long. s/ O.C",
      "Com Lat. Long. c/ O.C",
      "Com Lat. Long. c/ O.C c/ Alteração"
    ];

    // Corpo principal
    const body = sortedData.map(item => [
      item.COD_EQUIPAMENTO,
      item.percentual_automatica,
      item.percentual_automatica_com_alteracao,
      item.percentual_manual,
      item.percentual_sem_lat_long,
      item.percentual_c_lat_long_sem_oc,
      item.percentual_c_lat_long_com_oc,
      item.percentual_c_lat_long_com_oc_com_alt
    ]);

    // Linha total
    total.forEach(item => {
      body.push([
        `Total`,
        item.percentual_automatica,
        item.percentual_automatica_com_alteracao,
        item.percentual_manual,
        item.percentual_sem_lat_long,
        item.percentual_c_lat_long_sem_oc,
        item.percentual_c_lat_long_com_oc,
        item.percentual_c_lat_long_com_oc_com_alt
      ]);
    });

    // Tabela
    autoTable(doc, {
      head: [headers],
      body: body,
      startY: 80,
      margin: { top: 50, left: 20, right: 20 },
      styles: {
        fontSize: 10,
        cellPadding: 4
      },
      headStyles: {
        fillColor: [7, 99, 51],
        textColor: 255
      },
      didDrawPage: () => {
        doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(marcaDaguaBase64, 'JPEG', centerX, centerY, marcaW, marcaH);
        doc.setGState(new doc.GState({ opacity: 1 }));
      }
    });

    doc.save(`cdc_caminhao_${new Date().toLocaleString("pt-BR")}.pdf`);
  };




  return (
    <>

      <Geral>
        <div>

          {isLoading ? (
            <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
          ) : (
            <>
              {showGrid && (

                <>
                  <Table>
                    <Thead>
                      <Tr noHover>
                        <CabecalhoTabela colSpan={13}>
                          <HeaderWrapper>
                            <h2 >Caminhão</h2>

                            <Td3 >

                              <Input
                                type="text"
                                placeholder="Pesquisar..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                              <Select value={itemsPerPage} onChange={(e) => {
                                const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
                                setItemsPerPage(value);
                                setCurrentPage(1); // Resetar para a primeira página sempre que mudar
                              }}>
                                <option value={10}>10 por página</option>
                                <option value={50}>50 por página</option>
                                <option value={100}>100 por página</option>
                                <option value="all">Todos</option>
                              </Select>


                              <Div2>
                                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                  <ImArrowLeft size={20} />
                                </Button>
                                <span><strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
                                <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                  <ImArrowRight size={20} />
                                </Button>
                              </Div2>

                            </Td3>

                            <HeaderRight>
                              <IconGroup>
                                <Button onClick={gerarPdf} title="Exportar PDF">
                                  Exportar PDF
                                </Button>
                                <Button onClick={toggleFullscreen} title="Tela cheia">
                                  Tela cheia
                                </Button>
                              </IconGroup>
                            </HeaderRight>
                          </HeaderWrapper>
                        </CabecalhoTabela>

                      </Tr>

                    </Thead>

                    <Thead hideOnMobile>

                      <TrHead>
                        <Th onClick={() => onColumnClick("COD_EQUIPAMENTO")} className={getSortClass("COD_EQUIPAMENTO")}>
                          Frota: {getSortIcon("COD_EQUIPAMENTO")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_automatica")} className={getSortClass("percentual_automatica")}>
                          Automática {getSortIcon("percentual_automatica")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_automatica_com_alteracao")} className={getSortClass("percentual_automatica_com_alteracao")}>
                          Auto. c/ Alteração {getSortIcon("percentual_automatica_com_alteracao")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_manual")} className={getSortClass("percentual_manual")}>
                          Manual: {getSortIcon("percentual_manual")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_sem_lat_long")} className={getSortClass("percentual_sem_lat_long")}>
                          Sem Lat. Long.: {getSortIcon("percentual_sem_lat_long")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc")} className={getSortClass("percentual_c_lat_long_sem_oc")}>
                          Com Lat. Long. s/ O.C: {getSortIcon("percentual_c_lat_long_sem_oc")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc")} className={getSortClass("percentual_c_lat_long_com_oc")}>
                          Com Lat. Long. c/ O.C: {getSortIcon("percentual_c_lat_long_com_oc")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc_com_alt")} className={getSortClass("percentual_c_lat_long_com_oc_com_alt")}>
                          Com Lat. Long. c/ O.C c/ Alteração: {getSortIcon("percentual_c_lat_long_com_oc_com_alt")}
                        </Th>

                      </TrHead>
                    </Thead>

                    <colgroup>
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "14%" }} />
                    </colgroup>

                    <Tbody>
                      {sortedData.map((item, i) => (
                        <Tr key={i}>
                          <Td width="auto" data-label="Frota:">{item.COD_EQUIPAMENTO}</Td>
                          <Td width="auto" data-label="Automática:">{item.percentual_automatica}</Td>
                          <Td width="auto" data-label="Auto. c/ Alteração:">{item.percentual_automatica_com_alteracao}</Td>
                          <Td width="auto" data-label="Manual:">{item.percentual_manual}</Td>
                          <Td width="auto" data-label="Sem Lat. Long:">{item.percentual_sem_lat_long}</Td>
                          <Td width="auto" data-label="Com Lat. Long. s/ O.C:">{item.percentual_c_lat_long_sem_oc}</Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C:">{item.percentual_c_lat_long_com_oc}</Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C c/ Alteração:">{item.percentual_c_lat_long_com_oc_com_alt}</Td>

                        </Tr>
                      ))
                      }
                    </Tbody>


                  </Table>
                  <Table>

                    <colgroup>
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "14%" }} />
                    </colgroup>
                    <Tbody>
                      {total.map((item, i) => (
                        <Tr key={i}>
                          <Td width="auto" data-label="Total:"><strong>{item.TOTAL}</strong></Td>
                          <Td width="auto" data-label="Automática:"><strong>{item.percentual_automatica}</strong></Td>
                          <Td width="auto" data-label="Auto. c/ Alteração:"><strong>{item.percentual_automatica_com_alteracao}</strong></Td>
                          <Td width="auto" data-label="Manual:"><strong>{item.percentual_manual}</strong></Td>
                          <Td width="auto" data-label="Sem Lat. Long:"><strong>{item.percentual_sem_lat_long}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. s/ O.C:"><strong>{item.percentual_c_lat_long_sem_oc}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C:"><strong>{item.percentual_c_lat_long_com_oc}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C c/ Alteração:"><strong>{item.percentual_c_lat_long_com_oc_com_alt}</strong></Td>

                        </Tr>
                      ))
                      }
                    </Tbody>
                  </Table>
                </>
              )}
            </>
          )}






        </div>

      </Geral >

    </>

  );
};



export default Grid;
